import { render, staticRenderFns } from "./DebtorContactSelect.vue?vue&type=template&id=36239e96&"
import script from "./DebtorContactSelect.vue?vue&type=script&lang=js&"
export * from "./DebtorContactSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports